import { render, staticRenderFns } from "./StyleGuide.vue?vue&type=template&id=39c8d5c6&scoped=true"
import script from "./StyleGuide.vue?vue&type=script&lang=js"
export * from "./StyleGuide.vue?vue&type=script&lang=js"
import style0 from "./StyleGuide.vue?vue&type=style&index=0&id=39c8d5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c8d5c6",
  null
  
)

export default component.exports